import SectionThree from "../Componets/SectionThree"
import Footer from "../Componets/Footer";

import '../styles/style.css'

export default function Skills() {
    return (
        <>
            <div className="space-in-page" ></div>
            <SectionThree />
            <Footer />
        </>
    );
}
